export function subscribeMatchMedia(
    media: MediaQueryList,
    listener: () => void,
) {
    if (typeof media.addEventListener === "function") {
        media.addEventListener("change", listener);
        return () => media.removeEventListener("change", listener);
    }

    media.addListener(listener);
    return () => media.removeListener(listener);
}

/** Matches app mobile breakpoint (`$mobileBreakpoint` / Bootstrap lg). */
export function isMobileViewport(): boolean {
    if (typeof window === "undefined") {
        return false;
    }

    return window.matchMedia("(max-width: 991px)").matches;
}

/** iPhone, iPod, iPad (incl. iPadOS desktop UA). */
export function isIOSWebKit(): boolean {
    if (typeof navigator === "undefined") {
        return false;
    }

    return (
        /iPad|iPhone|iPod/.test(navigator.userAgent) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
    );
}

/** Prefer full navigation on iOS Safari — client-side transitions cancel in-flight fetches. */
export function shouldUseFullPageNavigation(): boolean {
    return isIOSWebKit();
}

export function replaceLocation(url: string) {
    window.location.replace(url);
}
